// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__27uOD","file":"styles_file__1hlf7"};